(function() {
  'use strict';

  /**
   * @ngdoc directive
   * @name webAgro1App.directive:widgetcronograma
   * @description
   * # widgetcronograma
   */
  angular
    .module('webAgro1App')
    .directive('widgetCronograma', WidgetCronograma);

  /**
   * Declare Widget Estação Meteorológica
   * @return {Object}
   */
  function WidgetCronograma() {

    //////////////////////////////////////////
    // Directive definition object
    var directive = {
      templateUrl: 'views/widgets/cronograma/view.html',
      restrict: 'A',
      controller: 'WidgetCronogramaCtrl',
      controllerAs: 'wctrl',
      scope: {
        widget: '=data'
      }
    };
    return directive;

  }

}());
